import { useEffect } from 'react'

const useOnUnmountEffect = (fn) => {
  useEffect(() => () => fn(), []) // eslint-disable-line
}

export default useOnUnmountEffect
